import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  loadingContainer: {
    position: 'absolute',
    left: 0, right: 0, top: 0, bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
    zIndex: 1,
  },
  webview: {
    flex: 1,
  },
});
